export default __webpack_public_path__ + "static/media/Freebooter's Bracers of the Yellow Spring.c6f684dc.jpg";